import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import currencySym from 'currency-symbol-map';

const AddOnField = ({
  input = {},
  meta = {},
  className = null,
  errorMessage = null,
  label = '',
  fieldType = 'number',
  isCurrency = false,
  leftLabel = false,
  attributes = {},
  isError = false
}) => {
  const fieldLabel = isCurrency ? currencySym(label) : label;
  const { error, submitFailed } = meta;
  const showError = isError || !!(error && submitFailed);
  const { className: inputClassName = '', ...restOfInput } = input;

  return (
    <div data-testing-id="add-on-field">
      <div className={classNames('input-group', className)}>
        {
          leftLabel && <div className={classNames('input-group-addon', { error: showError })}>{fieldLabel}</div>
        }
        <input
          {...restOfInput}
          className={classNames('form-control', inputClassName, { error: showError })}
          type={fieldType}
          {...attributes}
        />
        {
          !leftLabel && <div className={classNames('input-group-addon', { error: showError })}>{fieldLabel}</div>
        }
      </div>
      { showError &&
        <p className="error text-brand-danger text-small">{errorMessage || error}</p>
      }
    </div>
  );
};

AddOnField.propTypes = {
  input: PropTypes.object,
  meta: PropTypes.object,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  fieldType: PropTypes.string,
  isCurrency: PropTypes.bool,
  leftLabel: PropTypes.bool,
  attributes: PropTypes.object,
  errorMessage: PropTypes.string,
  isError: PropTypes.bool
};
export default AddOnField;
